import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { AddProduct } from "./AddProduct";
import { TableProducts } from "./TableProducts"
import { mapDocs } from "../../utils";

export const Products = () => {
  const querydb = getFirestore();

  const [data, setData] = useState();

  useEffect(() => {
    getDocs(collection(querydb, "products")).then((res) => {
      setData(mapDocs(res));
    });
  }, [querydb]);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    getDocs(collection(querydb, "products")).then((res) => {
      setData(mapDocs(res));
    });
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        onClick={showModal}
        type="primary"
        style={{
          marginBottom: 16,
        }}
        size="large"
      >
        Añadir producto
      </Button>
      <TableProducts data={data}/>
      <Modal
        title="Añadir Producto"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        okButtonProps={{
        style:{
          display:"none",
        },
      }}
      cancelButtonProps={{
        style:{
          display:"none",
        },
      }}
      >
        <AddProduct handleOk={handleOk} handleCancel={handleCancel}/>
      </Modal>
    </>
  );
};
